<template>
  <div class="invite-login">
    <div class="title">{{ $t('loginActivity.receiveReward') }}</div>
    <div class="content">
      <login-view
        :btnLabel="$t('loginActivity.registerReceive')"
        :agreementBarStyle="{ paddingTop: '33px' }"
        :btnBarStyle="{ padding: '17px 0 0' }"
      />
    </div>
  </div>
</template>

<script>
  import LoginView from '../login-view.vue'
  export default {
    name: 'invite-login',

    components: {
      LoginView
    }
  }
</script>

<style lang="scss" scoped>
  .invite-login {
    .title {
      font-size: 18px;
      font-weight: 600;
      line-height: 24px;
      color: #20283e;
      padding: 16px 16px 8px;
    }

    .content {
      padding: 0 40px;
    }
  }
</style>
